import React, { memo } from 'react';
import { Book, Zap, ShieldCheck, CreditCard } from 'lucide-react';
export const Hero: React.FC = () => {
  const checkoutUrl = 'https://checkout.ebookpoint.shop/cart/59546533036113';
  return <section className="w-full bg-gradient-to-b from-sky-50 to-white pt-6 pb-8 px-4 sm:px-6 lg:px-8" data-id="element-91">
      <div className="max-w-3xl mx-auto text-center" data-id="element-92">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-slate-900 tracking-tight leading-tight mb-4" data-id="element-93">
          No necesitás memorizar más.{' '}
          <span className="text-cyan-700 block sm:inline" data-id="element-94">
            Necesitás entender cómo funciona realmente el quirófano
          </span>
        </h1>

        <div className="relative mx-auto w-full max-w-xs sm:max-w-sm mb-4 rounded-xl overflow-hidden shadow-xl border border-slate-200" data-id="element-95">
          <img src="https://cdn.magicpatterns.com/uploads/wQwUtcwYaVYGsCjnsEBmo1/ChatGPT_Image_May_20,_2026,_05_21_49_PM.png" alt="Atlas del Instrumentador Quirúrgico" className="w-full h-auto object-cover" data-id="element-96" />
        </div>

        <p className="text-sm sm:text-base text-slate-700 font-medium max-w-2xl mx-auto mb-4 leading-snug" data-id="element-97">
          Aprendé a reconocer instrumental, entender la lógica quirúrgica y
          ganar seguridad REAL en prácticas hospitalarias con este atlas
          definitivo.
        </p>

        <div className="flex flex-wrap justify-center gap-2 mb-4" data-id="element-98">
          <div className="flex items-center gap-1.5 bg-cyan-50 text-cyan-800 px-3 py-1 rounded-full font-semibold text-xs border border-cyan-200" data-id="element-99">
            <Book className="w-3.5 h-3.5" data-id="element-100" />
            <span data-id="element-101">PDF Digital</span>
          </div>
          <div className="flex items-center gap-1.5 bg-amber-50 text-amber-700 px-3 py-1 rounded-full font-semibold text-xs border border-amber-200" data-id="element-102">
            <Zap className="w-3.5 h-3.5" data-id="element-103" />
            <span data-id="element-104">Acceso Inmediato</span>
          </div>
        </div>

        <a href={checkoutUrl} className="inline-block w-full sm:w-auto bg-cyan-600 hover:bg-cyan-700 text-white font-bold text-base sm:text-lg py-3 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5" data-id="element-105">
          QUIERO MI ATLAS AHORA
        </a>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 mt-3 text-[11px] sm:text-xs text-slate-500 font-medium" data-id="element-106">
          <div className="flex items-center gap-1" data-id="element-107">
            <CreditCard className="w-3 h-3" data-id="element-108" />
            <span data-id="element-109">Mercado Pago · Tarjeta</span>
          </div>
          <span className="text-slate-300" data-id="element-110">|</span>
          <div className="flex items-center gap-1" data-id="element-111">
            <ShieldCheck className="w-3 h-3" data-id="element-112" />
            <span data-id="element-113">Garantía 7 días</span>
          </div>
          <span className="text-slate-300" data-id="element-114">|</span>
          <div className="flex items-center gap-1" data-id="element-115">
            <ShieldCheck className="w-3 h-3 text-green-600" data-id="element-116" />
            <span className="text-green-700" data-id="element-117">Pago 100% seguro</span>
          </div>
        </div>
      </div>
    </section>;
};